<template>
    <div class="card">
        <div class="card-header">
            Kompilieren von 
            <b>{{fileName}}</b> 
            zu Groovy fehlgeschlagen...
        </div>
        <div class="card-body">
            <code><pre>{{errorMessage}}</pre></code>
        </div>
        <div class="card-footer">
            <div class="text-right mc-btn-margin">
                <button class="btn btn-secondary" @click="onAbort">OK</button> 
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "modal-cross-compile-error",
  props: ["fileName","errorMessage"],
  methods: { 
    onAbort() {
      this.$emit("close", null);
    }
  }
});
</script>

<style scoped>
</style>